export default __webpack_public_path__ + "static/media/skipIcon.982995c4.svg";